/* AŞAMA 7 POC — dnd-kit ile sürüklerken kenar otomatik kaydırma kanıtı.
   İZOLE: ana görev listesine dokunmaz. Yalnızca /poc-surukleme rotasında.
   Gerçek koşulu taklit eder:
     * kaydırma kabı Sidebar.jsx:769 ile AYNI sınıflar (flex-1 overflow-y-auto
       scrollbar-sertex p-3 space-y-2), sabit yükseklik
     * kartların TaskCard gibi kendi `overflow:auto` + `resize:both` sarmalayıcısı
*/
import React, { useState } from "react";
import { DragDropProvider } from "@dnd-kit/react";
import { useSortable } from "@dnd-kit/react/sortable";
import { AutoScroller } from "@dnd-kit/dom";
import { move } from "@dnd-kit/helpers";

// Kullanıcı isteği: "kenara yaklaştıkça hızlansın ama çok hızlı olmasın".
// acceleration varsayılanı 25 → çok hızlı (ölçüm: ~1200 px/s). 6 ile kontrollü
// bir akış elde edilir; eşik %20 (kabın yüksekliğinin %20'si = kenar bölgesi).
const AUTO_SCROLL = AutoScroller.configure({
  acceleration: 8,
  threshold: { x: 0, y: 0.2 },
});

const PocCard = ({ id, index }) => {
  const { ref, handleRef, isDragSource } = useSortable({ id, index });
  return (
    <div
      ref={ref}
      data-testid={`poc-item-${id}`}
      // TaskCard ile aynı tuzak: kendi kaydırılabilir + yeniden boyutlanabilir kabı
      style={{ overflow: "auto", resize: "both" }}
      className={`rounded border px-2 py-3 bg-sertex-surface/60 ${
        isDragSource ? "border-sertex-cyan" : "border-sertex-cyan/20"
      }`}
    >
      <div className="flex items-center gap-2">
        <button
          ref={handleRef}
          data-testid={`poc-drag-${id}`}
          className="h-5 w-4 cursor-grab active:cursor-grabbing touch-none text-sertex-cyan/70"
          aria-label="Sürükle sırala"
        >
          ⠿
        </button>
        <span className="hud-text text-sertex-text">POC KART {id}</span>
      </div>
    </div>
  );
};

export default function DragAutoScrollPoc() {
  const [items, setItems] = useState(() =>
    Array.from({ length: 30 }, (_, i) => String(i + 1).padStart(2, "0")),
  );
  return (
    <div className="min-h-screen bg-sertex-bg p-8" data-testid="poc-page">
      <h1 className="hud-text text-sertex-cyan text-lg mb-4">
        POC — sürüklerken kenar otomatik kaydırma (dnd-kit)
      </h1>
      {/* Gerçek kaydırma kabının birebir kopyası, sabit yükseklikli */}
      <div className="flex flex-col h-[600px] w-[420px] border border-sertex-cyan/30 rounded">
        <div className="px-3 py-2 hud-text text-sertex-textMuted border-b border-sertex-cyan/20">
          KAP (overflow-y-auto)
        </div>
        <DragDropProvider
          plugins={(defaults) => [
            ...defaults.filter((p) => p !== AutoScroller),
            AUTO_SCROLL,
          ]}
          onDragOver={(event) => setItems((cur) => move(cur, event))}
        >
          <div
            data-testid="poc-scroll"
            className="flex-1 overflow-y-auto scrollbar-sertex p-3 space-y-2"
          >
            {items.map((id, index) => (
              <PocCard key={id} id={id} index={index} />
            ))}
          </div>
        </DragDropProvider>
      </div>
      <div className="mt-4 hud-text text-sertex-textMuted text-xs" data-testid="poc-order">
        SIRA: {items.join(",")}
      </div>
    </div>
  );
}
